import React, { useState, useEffect } from "react";
import logo from "../img/premier_logo.png";
import "../css/Header.css";
import { useLocation } from "react-router-dom";
import ic_dropdown_arrow from "../img/ic_dropdown_arrow.png";
import LogoutPopup from "../components/LogoutPopup";
import axios from "axios";
import ic_hamburger_menu from "../img/ic_hamburger_menu.png";
import logo_dummy from "../img/premier_logo.png";

function Header() {

  const [cookieUserType, setCookieUserType] = useState(null);

  const [visibilityOfSideDrawer, setVisibilityOfSideDrawer] = useState(false);
  const [companyName, setCompanyName] = useState("");

  const initialCreditAndBalance = [
    {
      credit_limit: "",
      balance: "",
    },
  ];
  const [creditAndBalance, setCreditAndBalance] = useState(
    initialCreditAndBalance
  );

  const [visibilityOfOrderDropDown, setVisibilityOfOrderDropDown] =
    useState("none");

  const location = useLocation();

  const { pathname } = location;

  const splitLocation = pathname.split("/");

  const [logoutPopupStatus, setlogoutPopupStatus] = useState(false);

  const getHeaderData = () => {
    // get company code from local storage , then call API using that code

    let current_company_local = localStorage.getItem("current_company");
    let currentCompany;

    if (current_company_local) {

      currentCompany = JSON.parse(current_company_local);
      // console.log("Home page company value is  ", currentCompany);
      setCompanyName(currentCompany.company_name);

      const apiUrl = `${process.env.REACT_APP_BASE_URL}/CustomerInform/${currentCompany.company_code}`;
      axios
        .get(apiUrl)
        .then((res) => {
          // console.log("balance and credit is  ", res.data);
          setCreditAndBalance(res.data);
        })
        .catch((e) => {
          // console.log("something went wrong");
        });

    }
  };

  const closeDropDown = (e) => {
    if (e.target.tagName === "A") {
      //console.log("Link clicked");
      setVisibilityOfOrderDropDown("none");
    }
  };

  const showLogoutPopup = () => {
    //console.log("clicked somthing");
    setlogoutPopupStatus(!logoutPopupStatus);
  };

  const getCookie = (n) => {
    let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
    return a ? a[1] : "";
  };

  const showDepartmentOption = () => {

    // check user type from cookie and show dep sales option if user type is 
    // ADMIN

    if (document.cookie.length != 0) {
      console.log("iffff document.cookie.length != 0");

      if (getCookie("current_company_user_type")) {

        setCookieUserType(JSON.parse(getCookie("current_company_user_type")));
      }

    } else {
      console.log("elseeedocument.cookie.length != 0");
    }
  }

  useEffect(() => {

    if (cookieUserType != null) {

      console.log("iffff cookieUserType != null");
      if (cookieUserType.type != null) {
        console.log("iffff cookieUserType.type != null");
      } else {
        console.log("elseee cookieUserType.type != null");
      }

    } else {
      console.log("elseeee cookieUserType != null")
    }

  }, [cookieUserType])

  useEffect(() => {
    getHeaderData();
    showDepartmentOption();
  }, [])  // <-- add this empty array here


  const showHideMenuContainer = () => {
    setVisibilityOfSideDrawer(prev => !prev);
  }

  const mobileLogOutClick = () => {
    showHideMenuContainer();
    showLogoutPopup();
  }

  return (
    <div className={splitLocation[1] === "" ? "hideLoginContainer" : ""}>

      <div className="Header-logo-container">

        <a className="logo-container" href="/home">
          {/* <img src={logo} className="Header-logo shimmer" alt="logo" /> */}
          <img src={logo_dummy} className="Header-logo shimmer" alt="logo" />
        </a>

        <div className="Header-balance-statistics-container">


          <div className="Header-credit-balance-container ">

            <div className="welcome-company-name-container ms-4">
              {/* <span>Welcome </span> */}
              <span>{companyName}</span>
            </div>
            <div className="welcome-company-value-container ms-2 d-flex">
              <div className="Header-value-chip">
                <span className="Header-balance-label">Credit Limit :</span>{" "}
                <span className="Header-balance-value ms-2">
                  {creditAndBalance[0] ? creditAndBalance[0].credit_limit : ""}
                </span>{" "}
              </div>
              <div className="Header-value-chip ms-2">
                <span className="Header-balance-label ms-2" >Used :</span> {" "}
                <span className="Header-balance-value ms-2">
                  {" "}
                  {creditAndBalance[0] ? creditAndBalance[0].balance : ""}{" "}
                </span>{" "}
              </div>
              <div className="Header-value-chip ms-2">
                <span className="Header-balance-label ms-2" >Available :</span> {" "}
                <span className="Header-balance-value ms-2">
                  {" "}
                  { creditAndBalance[0]?.credit_limit - creditAndBalance[0]?.balance }
                </span>{" "}
              </div>
            </div>

          </div>

        </div>

        <button className="Header-hamburger-button show-only_in_mobile" onClick={showHideMenuContainer}>
          <img src={ic_hamburger_menu} />
        </button>

        {/* mobile view */}

        {
          visibilityOfSideDrawer &&
          <div className="Header-hamburger-menu-outer-container show-only_in_mobile">

            <nav className="mobile-list-menu-container">
              <h4 className="p-4">Menu</h4>

              <ul className="mobile-list-menu-container-ul">
                <li className={splitLocation[1] === "home" ? "active" : ""} onClick={showHideMenuContainer}>
                  <a href="/home">Home</a>
                </li>

                <li>
                  <div className="mobile-list-menu-container-Sublist-header pb-2">
                    Order &amp; Tracking{" "}
                    <img
                      src={ic_dropdown_arrow}
                      className="Header-dropdown-arrow-icon"
                      alt="drop down arrow"
                    />
                  </div>

                  <ul className="mobile-list-menu-container-orderAndtracking-navList-item">
                    <li
                      className={
                        splitLocation[1] === "createEnquiry"
                          ? "Header-orderAndtracking-navList-item Header-navLink-main-menu active"
                          : "Header-orderAndtracking-navList-item Header-navLink-main-menu"
                      } onClick={showHideMenuContainer}>
                      <a href="/createEnquiry" className="Header-navLink">Create Enquiry</a>
                    </li>

                    {/* <li className={
                      splitLocation[1] === "listOfEnquiry"
                        ? "Header-orderAndtracking-navList-item Header-navLink-main-menu active"
                        : "Header-orderAndtracking-navList-item Header-navLink-main-menu"
                    } onClick={showHideMenuContainer}>
                      <a href="/listOfEnquiry" className="Header-navLink">
                        List of Enquiry
                      </a>
                    </li>
                    <li className={
                      splitLocation[1] === "listOfOrder"
                        ? "Header-orderAndtracking-navList-item Header-navLink-main-menu active"
                        : "Header-orderAndtracking-navList-item Header-navLink-main-menu"
                    } onClick={showHideMenuContainer}>
                      <a href="/listOfOrder" className="Header-navLink">
                        List of Order
                      </a>
                    </li>
                    <li
                      className={
                        splitLocation[1] === "listOfReturn"
                          ? "Header-orderAndtracking-navList-item Header-navLink-main-menu active"
                          : "Header-orderAndtracking-navList-item Header-navLink-main-menu"
                      } onClick={showHideMenuContainer}>
                      <a href="/listOfReturn" className="Header-navLink">
                        List of Return
                      </a>
                    </li> */}


                  </ul>
                </li>

                {/* <li className={
                  splitLocation[1] === "viewOrderStatistics" ? "active" : ""
                } onClick={showHideMenuContainer}>
                  <a
                    href="/viewOrderStatistics"

                  >
                    View Order Statistics
                  </a>{" "}
                </li> */}

                {


                  cookieUserType != null ?
                    cookieUserType.type == "ADMIN" ?
                      <li
                        className={splitLocation[1] === "department-wise-sales" ? "active" : ""}
                        onClick={showHideMenuContainer}>
                        <a
                          href="/department-wise-sales"
                        >
                          Department Wise Sales
                        </a>{" "}
                      </li>
                      :
                      null
                    :
                    null
                }


                {/* <li className={splitLocation[1] === "help" ? "active" : ""}
                  onClick={showHideMenuContainer}>
                  <a href="/help">
                    Help
                  </a>{" "}
                </li> */}

                {/* <li className={splitLocation[1] === "contact" ? "active" : ""}
                  onClick={showHideMenuContainer}>
                  <a
                    href="/contact">
                    Contact
                  </a>{" "}
                </li> */}

                <li className="Header-nav-logout" onClick={mobileLogOutClick}>
                  Logout
                </li>
              </ul>
            </nav>
          </div>
        }

      </div>

      {/* logo container ends */}

      {/* desktop view */}
      <nav className="Header-nav show-in-desktop-only">
        <ul>
          <li>
            <a
              href="/home"
              className={splitLocation[1] === "home" ? "active" : ""}
            >
              Home
            </a>
          </li>
          <li
            onClick={closeDropDown}
            onMouseOver={() => setVisibilityOfOrderDropDown("block")}
            onMouseLeave={() => setVisibilityOfOrderDropDown("none")}
          >
            <a
              href="/createEnquiry"
              className={
                splitLocation[1] === "createEnquiry" ||
                  splitLocation[1] === "listOfEnquiry" ||
                  splitLocation[1] === "listOfOrder" ||
                  splitLocation[1] === "listOfReturn" ||
                  splitLocation[1] === "viewEnquiry" ||
                  splitLocation[1] === "orderPlacing" ||
                  splitLocation[1] === "viewOrder" ||
                  splitLocation[1] === "returnRequest" ||
                  splitLocation[1] === "viewReturnRequest"
                  ? "Header-navLink-main-menu active"
                  : "Header-navLink-main-menu"
              }
            >
              Order &amp; Tracking{" "}
              <img
                src={ic_dropdown_arrow}
                className="Header-dropdown-arrow-icon"
                alt="drop down arrow"
              />
            </a>
            <ul
              className={
                visibilityOfOrderDropDown === "none"
                  ? "Header-nav-orderAndtracking-subMenu"
                  : "Header-nav-orderAndtracking-subMenu Header-show-drop-down"
              }
            >
              <li className="Header-orderAndtracking-navList-item">
                <a href="/createEnquiry" className="Header-navLink">
                  Create Enquiry
                </a>
              </li>

              {/* <li className="Header-orderAndtracking-navList-item">
                <a href="/listOfEnquiry" className="Header-navLink">
                  List of Enquiry
                </a>
              </li>
              <li className="Header-orderAndtracking-navList-item">
                <a href="/listOfOrder" className="Header-navLink">
                  List of Order
                </a>
              </li>
              <li className="Header-orderAndtracking-navList-item">
                <a href="/listOfReturn" className="Header-navLink">
                  List of Return
                </a>
              </li> */}


            </ul>
          </li>

          {/* <li>
            <a
              href="/viewOrderStatistics"
              className={
                splitLocation[1] === "viewOrderStatistics" ? "active" : ""
              }
            >
              View Order Statistics
            </a>{" "}
          </li> */}

          {
            cookieUserType != null ?
              cookieUserType.type == "ADMIN" ?
                <li>
                  <a
                    href="/department-wise-sales"
                    className={splitLocation[1] === "department-wise-sales" ? "active" : ""}
                  >
                    Department Wise Sales
                  </a>{" "}
                </li>
                :
                null
              :
              null
          }

          {/* <li>
            <a
              href="/help"
              className={splitLocation[1] === "help" ? "active" : ""}
            >
              Help
            </a>{" "}
          </li> */}
          
          {/* <li>
            <a
              href="/contact"
              className={splitLocation[1] === "contact" ? "active" : ""}
            >
              Contact
            </a>{" "}
          </li> */}

          <li className="Header-nav-logout" onClick={showLogoutPopup}>
            Logout
          </li>
        </ul>
      </nav>

      {logoutPopupStatus && <LogoutPopup showLogoutPopup={showLogoutPopup} />}
    </div>
  );
}

export default Header;
